import dayjs, { Dayjs } from 'dayjs';

export default {
  methods: {
    async setWeather(weatherResponse: any, date: string) {
      let day = this.getDeliveryDateDifference(date);

      sessionStorage.setItem("temperature", weatherResponse.temps[day]);
      sessionStorage.setItem("weather", weatherResponse.weather[day] || "");
    },
    getDeliveryDateDifference(date: string) {
      const chosenDate: Dayjs = dayjs(date).startOf("day");
      const today: Dayjs = dayjs().startOf("day")
      const diffInDays: number = chosenDate.diff(today, 'day');
      return diffInDays;
    },
    getWeatherIcon(weather: string) {
      let iconUrl = "";
      switch (weather) {
        case "clouds":
          iconUrl = "https://cdn.buttercms.com/zAOVkwd8Sxdb8LSDW7nQ";
          break;
        case "drizzle":
        case "rain":
          iconUrl = "https://cdn.buttercms.com/mSW1vKZ8TBCN1izicN8A";
          break;
        case "snow":
          iconUrl = "https://cdn.buttercms.com/nffMK9ViSRSSJle8eaNg";
          break;
        case "thunder":
          iconUrl = "https://cdn.buttercms.com/hjhsPQtsTkCKeBTVdSxT";
          break;
        case "clear":
          iconUrl = "https://cdn.buttercms.com/e3DHdkzfQZWaaLVENGU3";
          break;
        default:
          iconUrl = "https://cdn.buttercms.com/UVUmmA3tTgy28I2elXxW";
      }
      return iconUrl;
    },
    getWeatherText(temperature: number) {
      let str = "";
      if (temperature <= -5) {
        str = "brr_weather";
      } else if (temperature > -5 && temperature <= 20) {
        str = "perfect_weather";
      } else {
        str = "scorcher_weather";
      }

      return str;
    },
  },
};
